import { render, staticRenderFns } from "./MigrateVolume.vue?vue&type=template&id=545815ac&scoped=true&"
import script from "./MigrateVolume.vue?vue&type=script&lang=js&"
export * from "./MigrateVolume.vue?vue&type=script&lang=js&"
import style0 from "./MigrateVolume.vue?vue&type=style&index=0&id=545815ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545815ac",
  null
  
)

export default component.exports